$shm_hitalama_entergate_app $shm_hitalama_entergate
	Form $shm_hitalama_entergate_app_form

$shm_hitalama_entergate_app_form $shm_hitalama_entergate_form
	sub /
		<= Title
		<= Mode_tabs
		<= Mode_field
		<= Actions
		<= Message
